import React from 'react';
import type {DataFormPartRenderer} from 'schema/types';
import type {Part} from 'schemaDefinition/types';
import {FieldLabel, FlexBox} from 'components';
import {useDataFormContext} from 'schema/form/contexts';
import {useLabelAndPlaceholder} from 'schema/form/hooks';
import {WorkPrizes} from '../WorkPrizes';

export const DataFormWorkPrizes: DataFormPartRenderer = ({
  part,
  valuePath,
  useValue,
}) => {
  const {id} = useDataFormContext();
  const value = useValue(valuePath, id);
  const {label} = useLabelAndPlaceholder(part as Part);

  return value ? (
    <FlexBox>
      {label ? <FieldLabel label={label} /> : null}
      <WorkPrizes part={part as Part} value={value} />
    </FlexBox>
  ) : null;
};
